import { render, staticRenderFns } from "./d-profile-direct-submissions.vue?vue&type=template&id=280dfdee&"
import script from "./d-profile-direct-submissions.vue?vue&type=script&lang=js&"
export * from "./d-profile-direct-submissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports